import { Dispatch } from 'react';
import { IAction } from 'appRedux/reducers';

import { ICasinoSchema, ILinkPlayerInfo } from '../models/casinoModels';
import { ICasinoSearchData } from 'appRedux/createStore';
import type { ApplicationConfigRow } from 'lib/applicationConfig';

const casinoReduxKey = 'CASINO';

export const casinoActionTypes = {
  SET_CASINO_SCHEMA_STATE: `${casinoReduxKey}-SET_CASINO_SCHEMA_STATE`,
  SET_LINKED_PLAYER_STATE: `${casinoReduxKey}-SET_LINKED_PLAYER_STATE`,
  SET_CASINO_SEARCH_DATA: `${casinoReduxKey}-SET_CASINO_SEARCH_DATA`,
  SET_APPLICATION_CONFIGURATIONS: `${casinoReduxKey}-SET_APPLICATION_CONFIGURATIONS`,
  MARK_CASINO_ENTRY: `${casinoReduxKey}-MARK_CASINO_ENTRY`,
};

export const CasinoReduxCommandCreator = (dispatch: Dispatch<IAction>) => {
  return {
    /** Sets the casinos linked player card data */
    SetLinkedCasinos(state: ILinkPlayerInfo) {
      dispatch({
        type: casinoActionTypes.SET_LINKED_PLAYER_STATE,
        state,
      });
    },
    /** Sets the player's currently selected casino information */
    SetCasinoSchema(state: ICasinoSchema) {
      dispatch({
        type: casinoActionTypes.SET_CASINO_SCHEMA_STATE,
        state,
      });
    },
    SetCasinoSearchData(state: ICasinoSearchData) {
      dispatch({
        type: casinoActionTypes.SET_CASINO_SEARCH_DATA,
        state,
      });
    },
    SetApplicationConfigurations(rows: ApplicationConfigRow[]) {
      dispatch({
        type: casinoActionTypes.SET_APPLICATION_CONFIGURATIONS,
        state: rows,
      });
    },
    /** Signals that a casino was just entered (selected) — bumps a counter so
     *  views can re-run their "fresh entry" reset even when the casino didn't
     *  change (re-selecting the casino you were already in). */
    MarkCasinoEntry() {
      dispatch({
        type: casinoActionTypes.MARK_CASINO_ENTRY,
      });
    },
  };
};
